export default "__VITE_ASSET__8e76d9be__"